module.exports = __webpack_public_path__ + "img/brrzzz@2x.18fa1e00.png";